<template>
  <header class="navigation-header">
    <div class="container-wrapper">
      <div class="logo-section">
        <div class="logo-icon">AI</div>
        <div class="logo-title">株価<span>アナライザー</span></div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderNavigation'
}
</script>

<style scoped>
.container-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.navigation-header {
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 224, 255, 0.2);
}

.logo-section {
  font-size: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-title span {    
  color: var(--brand-secondary);
}

.logo-icon {
  width: 36px;
  height: 36px;
  background-color: var(--brand-primary);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.logo-icon:after {
  content: '';
  position: absolute;
  width: 150%;
  height: 150%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transform: translateX(-100%);
  animation: glow-animation 4s infinite;
}

@keyframes glow-animation {
  0% { transform: translateX(-100%); }
  20%, 100% { transform: translateX(100%); }
}

@media (max-width: 768px) {
  .navigation-header {
    padding: 8px 0;
  }
}
</style> 